import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  input,
} from '@angular/core';
import { EtJournalESeal, EtJournalSealSource } from '@et/typings';

const SOURCE_LABEL: Record<EtJournalSealSource, string> = {
  seal: 'Seal',
  eSeal: 'eSeal',
  deletedESeal: 'Deleted eSeal',
};

const SOURCE_CLASS: Record<EtJournalSealSource, string> = {
  seal: 'bg-base-200 text-midnight',
  eSeal: 'bg-success/10 text-success',
  deletedESeal: 'bg-error/10 text-error',
};

@Component({
  selector: 'et-journal-seal-tag',
  imports: [],
  templateUrl: './seal-tag.component.html',
  styleUrl: './seal-tag.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  host: {
    class:
      'inline-flex items-center rounded-full px-2 py-0.5 text-xs font-semibold uppercase tracking-wide',
  },
})
export class SealTagComponent {
  seal = input.required<EtJournalESeal>();

  @HostBinding('class') get class() {
    return SOURCE_CLASS[this.seal().source];
  }

  get label(): string {
    return SOURCE_LABEL[this.seal().source];
  }
}
